/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import PropTypes from "prop-types";
import {useEffect, useState} from "react";

const PersonsListPagination = ({itemsPerPage, activePage, setActivePage, setItemsPerPage, totalCount, limit}: any) => {

    const [pageSize, setPageSize] = useState(itemsPerPage)

    useEffect(() => {
        setPageSize(itemsPerPage)
    })

    return (
        <div className='row'>
            <div
                className='col-sm-12 col-md-2 d-flex align-items-center justify-content-center justify-content-md-start'>
                <select className='form-select form-select-solid select2-hidden-accessible w-70px pointer'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    data-kt-user-table-filter='role'
                    data-hide-search='true'
                    defaultValue={pageSize}
                    onChange={(e) => {
                        setActivePage(1)
                        setItemsPerPage(Number(e.target.value))
                    }}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                </select>
            </div>
            <div className='col-sm-12 col-md-10 d-flex align-items-center justify-content-center justify-content-md-end'>
                <div id='kt_table_users_paginate'>
                    <ul className='pagination'>
                        <li className={clsx('page-item')}>
                            <button type={"button"} className={clsx('btn btn-sm btn-light pointer', {
                                disabled: activePage === 1
                            })}
                                    onClick={() => setActivePage((page: number) => page - 1)}
                                    style={{cursor: 'pointer'}}>
                                <i className="fa fa-chevron-left"></i>
                            </button>
                        </li>
                        <li className={clsx('page-item')}>
                            <button type="button" className={clsx('btn btn-sm btn-light pointer', {
                                disabled: (totalCount < itemsPerPage || (activePage * itemsPerPage) >= limit )
                            })}
                                    onClick={() => setActivePage((page: number) => page + 1)}
                                    style={{cursor: 'pointer'}}>
                                <i className="fa fa-chevron-right"></i>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

PersonsListPagination.propTypes = {
    loading: PropTypes.bool,
    activePage: PropTypes.number,
    pages: PropTypes.number,
    itemsPerPage: PropTypes.number,
    setActivePage: PropTypes.func,
    setItemsPerPage: PropTypes.func,
    totalCount: PropTypes.number,
    limit: PropTypes.number
}

export {PersonsListPagination}
